import { render, staticRenderFns } from "./GroupListCollecting.vue?vue&type=template&id=63bc0ba6&scoped=true"
import script from "./GroupListCollecting.vue?vue&type=script&lang=js"
export * from "./GroupListCollecting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bc0ba6",
  null
  
)

export default component.exports